import { useLazyDataModel } from '@thd-nucleus/data-sources';
import { pushEventInfo, getAnalyticsSettingsValue } from '../utils/analytics';

export const useEmailQuote = (
  printOption,
  onCompleted = () => {},
  onError = () => {}
) => {
  const pushAnalyticsShareAction = () => {
    pushEventInfo({
      category: {
        primaryCategory: 'button submission'
      },
      eventInfo: {
        eventName: 'my account settings'
      },
      myAccount: {
        settings: getAnalyticsSettingsValue(printOption)
      }
    });
  };

  const [handleEmailQuote, { data, loading }] = useLazyDataModel('emailQuote', {
    onCompleted: () => {
      pushAnalyticsShareAction();
      onCompleted();
    },
    onError: (error) => {
      // eslint-disable-next-line no-console
      console.error(error);
      onError();
    },
    errorPolicy: 'none',
    fetchPolicy: 'network-only', // Used for first execution
    nextFetchPolicy: 'network-only', // Used for subsequent executions
  });

  return [handleEmailQuote, { data, loading }];
};
